import {IBot, IBotUser, IDialogueCard, IParticipant} from './interfaces';
import {IAction} from '../interface';
import {InferActionsTypes} from '../helpers';
import {IXpedition} from '../../utils/hooks/use-chat-bot/interfaces';

export const SET_DIALOGUES = 'SET_DIALOGUES';
export const setDialogues = (dialogues: IDialogueCard[]): IAction<IDialogueCard[]> => ({
  type: SET_DIALOGUES,
  payload: dialogues
});
export const PARTICIPANTS_LOADED = 'PARTICIPANTS_LOADED';
export const participantsLoadedAction = (participants: IParticipant[]): IAction<IParticipant[]> => ({
  type: PARTICIPANTS_LOADED,
  payload: participants
});
export const PARTICIPANT_LOADED = 'PARTICIPANT_LOADED';
export const participantLoadedAction = (participant: IParticipant): IAction<IParticipant> => ({
  type: PARTICIPANT_LOADED,
  payload: participant
});
export const PARTICIPANT_ERROR = 'PARTICIPANT_ERROR';
export const participantErrorAction = (participantError: string): IAction<string> => ({
  type: PARTICIPANT_ERROR,
  payload: participantError
});
export const CLEAR_PARTICIPANT_ERROR = 'CLEAR_PARTICIPANT_ERROR';
export const clearParticipantErrorAction = (): IAction<null> => ({
  type: CLEAR_PARTICIPANT_ERROR,
  payload: null
});
export const SET_NOT_FOUND_EMAILS = 'SET_NOT_FOUND_EMAILS';
export const setNotFoundEmails = (emails: string[]): IAction<string[]> => ({
  type: SET_NOT_FOUND_EMAILS,
  payload: emails
});
export const CLEAR_NOT_FOUND_EMAILS = 'CLEAR_NOT_FOUND_EMAILS';
export const clearNotFoundEmails = (): IAction<null> => ({
  type: CLEAR_NOT_FOUND_EMAILS,
  payload: null
});
export const DIALOGUE_LOADED = 'DIALOGUE_LOADED';
export const dialogueLoadedAction = (dialogue: IDialogueCard): IAction<IDialogueCard> => ({
  type: DIALOGUE_LOADED,
  payload: dialogue
});
export const DIALOGUE_CLEARED = 'DIALOGUE_CLEARED';
export const dialogueClearedAction = (): IAction<null> => ({
  type: DIALOGUE_CLEARED,
  payload: null
});
export const BOTS_LOADED = 'BOTS_LOADED';
export const botsLoadedAction = (bots: IBot[]): IAction<IBot[]> => ({
  type: BOTS_LOADED,
  payload: bots
});
export const USERS_LOADED = 'USERS_LOADED';
export const usersLoadedAction = (users: IBotUser[]): IAction<IBotUser[]> => ({
  type: USERS_LOADED,
  payload: users
});
export const XPEDITIONS_LOADED = 'XPEDITIONS_LOADED';
export const xpeditionsLoadedAction = (xpeditions: IXpedition[]): IAction<IXpedition[]> => ({
  type: XPEDITIONS_LOADED,
  payload: xpeditions
});

const dialogueActions = {
  setDialogues,
  dialogueLoadedAction,
  participantsLoadedAction,
  participantLoadedAction,
  participantErrorAction,
  clearParticipantErrorAction,
  botsLoadedAction,
  usersLoadedAction,
  dialogueClearedAction,
  xpeditionsLoadedAction,
  setNotFoundEmails,
  clearNotFoundEmails
};

export type DialogueActionsType = InferActionsTypes<typeof dialogueActions>
